<template>
  <div class="flex flex-col text-sm text-center text-gray-500 dark:text-neutral-400">
    <span class="text-center">
      &copy; {{ currYear }} RGCC | Este portal web únicamente utiliza cookies con finalidad técnica, no recaba ni cede datos de carácter personal de los usuarios sin su conocimiento.
    </span>
    <span>
      Ver
      <a href="https://www.rgcc.es/aviso-legal" class="text-secondary underline" target="_blank">Aviso Legal</a>
      ,
      <a href="https://www.rgcc.es/cookies" class="text-secondary underline" target="_blank">Política de cookies</a>
      y
      <a href="https://www.rgcc.es/privacidad" target="_blank" class="text-secondary underline">Privacidad</a>
    </span>
  </div>
</template>

<script>
export default {
  name: 'CopyLegal',
  data: function () {
    return {
      currYear: '...'
    }
  },
  created: function () {
    this.setDate()
  },
  methods: {
    setDate: function () {
      const date = new Date()
      this.currYear = date.getFullYear()
    }
  }
}
</script>
